export enum TiposDeStatusDeEnvio {
  Aprovado = 'Aprovado',
  AguardandoAnalise = 'Aguardando análise',
  Recusado = 'Recusado',
  PendenteEnvio = 'Pendente de envio'
}
